import { render, staticRenderFns } from "./SettingsPatientUsersForm.vue?vue&type=template&id=4f2a1a99&scoped=true"
import script from "./SettingsPatientUsersForm.vue?vue&type=script&lang=js"
export * from "./SettingsPatientUsersForm.vue?vue&type=script&lang=js"
import style0 from "./SettingsPatientUsersForm.vue?vue&type=style&index=0&id=4f2a1a99&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2a1a99",
  null
  
)

export default component.exports